<!-- 
    checkbox多选框
    author:xxk 
    https://element.eleme.io/#/zh-CN/component/checkbox
 -->
<template>
  <el-checkbox-group v-model="valueModel" v-bind="checkboxGroupPropsResult" class="AppCheckboxGroup-root">
    <el-checkbox v-bind="checkboxProps" v-for="item in checkboxList" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
  </el-checkbox-group>
</template>
<script>
  import {vModel} from '@/mixins/vModel.js';
  export default {
    name: 'AppCheckboxGroup',
    mixins:[vModel],
    props: {
      // checkbox-group组件属性
      checkboxGroupProps: { type: Object, default() { return {}; } },
      // checkbox组件属性
      checkboxProps: { type: Object, default() { return {}; } },
      // 列表
      checkboxList: { type: Array, default() { return []; } },
    },
    computed:{
      // 组件属性合并结果
      checkboxGroupPropsResult(){
        return Object.assign(
          {
            clearable: true,
          },
          this.$attrs,
          this.checkboxGroupProps,
        );
      }
    },
  };
</script>
<style scoped lang="less"></style>
